/**
 * @Author: Ygm
 * @Date: 2024-07-10 13:35:26
 * @LastEditors: Ygm
 * @LastEditTime: 2025-07-29 15:38:02
 * @Description: 监听用户操作行为，判断是否长时间未操作
 */
let isActive = false // 用户活动状态
const DEBOUNCE_TIME = 300 // 防抖时间300ms
const INACTIVE_TIME = 60 * 1000 // 非活动时间1分钟
const newChannel = new BroadcastChannel('public_channel')

// 防抖处理后的resetTimer
const debouncedResetTimer = debounce(resetTimer, DEBOUNCE_TIME)

// 重置计时器函数，并在用户未操作时进行倒计时
function resetTimer() {
  let timer = null // 定义一个定时器变量
  clearTimeout(timer) // 清除之前的定时器

  isActive = true // 设置为活动状态
  notifyInactive(true)

  // 重置活动状态
  timer = setTimeout(() => {
    isActive = false // 设置为非活动状态

    clearTimeout(timer)
    notifyInactive(false)
  }, INACTIVE_TIME)
}

// 通知其他窗口或标签页用户非活动状态
function notifyInactive(isActive = false) {
  if (newChannel) {
    newChannel.postMessage({
      type: 'userActivityStatus',
      form: 'info_input',
      isActive
    })
  }
}

// 添加事件监听器
function addEventListeners(element) {
  element.addEventListener('mousemove', debouncedResetTimer)
  element.addEventListener('click', debouncedResetTimer)
  element.addEventListener('keydown', debouncedResetTimer)
}

// 移除事件监听器
function removeEventListeners(element) {
  element.removeEventListener('mousemove', debouncedResetTimer)
  element.removeEventListener('click', debouncedResetTimer)
  element.removeEventListener('keydown', debouncedResetTimer)
}

/**
 * @description 添加活动监听器
 * @param iframeId {string} iframe的id
 */
function setupActivityListeners(iframeId = '') {
  addEventListeners(document)

  const iframe = document.getElementById(iframeId)
  if (iframe) {
    iframe.addEventListener('load', () => {
      try {
        const iframeDoc = iframe.contentWindow.document
        addEventListeners(iframeDoc)
      } catch (e) {
        console.error('无法访问iframe内容:', e)
      }
    })
  }
}

/**
 * @description 移除活动监听器
 * @param iframeId {string} iframe的id
 */
function removeActivityListeners(iframeId = '') {
  removeEventListeners(document)
  newChannel && newChannel.close()

  const iframe = document.getElementById(iframeId)
  if (iframe) {
    iframe.removeEventListener('load', () => {
      try {
        const iframeDoc = iframe.contentWindow.document
        removeEventListeners(iframeDoc)
      } catch (e) {
        console.error('无法访问iframe内容:', e)
      }
    })
  }
}

// 防抖函数
function debounce(func, wait) {
  let timeout
  return function (...args) {
    clearTimeout(timeout)
    timeout = setTimeout(() => func.apply(this, args), wait)
  }
}

export { setupActivityListeners, removeActivityListeners, debouncedResetTimer }



// WEBPACK FOOTER //
// ./src/activityListeners.js